/* `pull` is a verbatim fragment of `quote`; `short` is the trimmed quote shown in the mobile carousel. */
export const TESTIMONIALS = [
  {
    id: 'damien',
    author: 'Damien H',
    initials: 'DH',
    pull: 'Completely changed the way I analyse races.',
    quote:
      "Horse Stat completely changed the way I analyse races. I couldn't imagine betting without it now.",
    short: "I couldn't imagine betting without it now.",
  },
  {
    id: 'jules',
    author: 'Jules C',
    initials: 'JC',
    pull: 'Opened up value opportunities in the market for me every week.',
    quote:
      'As someone who used to only bet at big festivals where I could use stats and trends to my advantage, Horse Stat has opened up value opportunities in the market for me every week. The easy to use racecards and stats cover every possible angle I could imagine and have allowed me to refine my strategy over time.',
    short: 'The easy-to-use racecards and stats cover every possible angle and have helped me refine my strategy over time.',
  },
  {
    id: 'george',
    author: 'George S',
    initials: 'GS',
    pull: 'I can finally look at a race and feel confident in my decisions.',
    quote:
      "I'm nowhere near being a professional punter, but Horse Stat made me feel like one. It breaks everything down in a way that's easy to understand without dumbing it down. I can finally look at a race and feel confident in my decisions.",
    short: "It breaks everything down in a way that's easy to understand without dumbing it down.",
  },
];
